import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useToast,
} from "@chakra-ui/react";

import { appRequest } from "routes";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  id?: string;
  handleUpdate: () => void;
  status:boolean
};

export default function DeleteModal({
  isOpen,
  onClose,
  id,
  handleUpdate,
  status
}: ModalProps): JSX.Element {
  const toast = useToast();
  const [deleteWorkFlowLoading, setDeleteWorkFlowLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setDeleteWorkFlowLoading(true);
      const response: any = await appRequest("workflow", "delete", { id: id });
      if (response) {
        if (response.status && response.status === "success") {
          toast({
            title: `Workflow deleted successfully.`,
            description: `We've deleted your workflow.`,
            status: "success",
            duration: 9000,
            isClosable: true,
            position: "top-right",
          });
          handleUpdate();
          onClose();
        } else {
          toast({
            title: `Error Deleting the workflow.`,
            description: response.code || response.message,
            status: "error",
            duration: 9000,
            isClosable: true,
            position: "top-right",
          });
        }
      } else {
        toast({
          title: `Error Deleting the workflow.`,
          description: response.message,
          status: "error",
          duration: 9000,
          isClosable: true,
          position: "top-right",
        });
      }
    } catch (error: any) {
      toast({
        title: `Error Deleting the workflow.`,
        description: error.message || "Something went wrong.",
        status: "error",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setDeleteWorkFlowLoading(false);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            fontWeight="500"
            color="red"
            mt={10}
            textAlign="center"
          >
            This action cannot be undone. Deleting this{" "}
            <Text as="span">Workflow</Text> will remove all associated
            permissions.
          </Text>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            fontWeight="700"
            color="red"
            mt={1}
            textAlign="center"
          >
            Please confirm?
          </Text>
        </ModalBody>

        <ModalFooter
          gap={6}
          mt={2}
          justifyItems="center"
          justifyContent="center"
          my={6}
        >
          <Button
            type="submit"
            w="70px"
            bg="teal.300"
            color="white"
            _hover={{
              bg: "teal.400",
            }}
            onClick={handleDelete}
            isLoading={deleteWorkFlowLoading}
            isDisabled={status}
          >
            Yes
          </Button>
          <Button onClick={onClose} colorScheme="red" color="white" w="70px">
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
